/** @format */

import React from "react";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { useState } from "react";
import { updateSelectVariable } from "../../../../../store/reducers/pdfeditor/toolsModificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";

let font = [
  "Georgia",
  "sans-serif",
  "serif",
  "Gill Sans",
  "cursive",
  " system-ui",
];
const FontFamily = () => {
  const [selectedFont, setSelectedFont] = useState("");
  const dispatch = useDispatch();
  const { currVariable } = useSelector((state) => state.toolsModification);

  const handleFontChange = (event) => {
    let val = event.target.value;
    let data = { fontFamily: val };
    dispatch(updateSelectVariable(data));
    dispatch(updateCoordinate({ id: currVariable?.variable, newValue: data }));
    setSelectedFont(val);
  };

  return (
    <Wrapper>
      <Stack direction='row' alignItems='center' spacing={1}>
        <p>Font Family</p>
        <select
          disabled={currVariable?.data_type === "image"}
          value={selectedFont}
          onChange={handleFontChange}
        >
          {font.map((item, index) => (
            <option key={index} value={item}>
              {item}
            </option>
          ))}
        </select>
      </Stack>
    </Wrapper>
  );
};

export default FontFamily;

const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 22%;
  }
  p {
    font-size: 12px;
  }
`;
